
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gov-solution",
      function () {
        return require("private-next-pages/gov-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gov-solution"])
      });
    }
  